/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = '___locache___/publisherReports/filters';

const getLocalStorage = (fieldName, defaultValue) => {
  try {
    const item = window.localStorage.getItem(STORAGE_KEY);
    return JSON.parse(item)?.[fieldName] ?? defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const publisherReportsFiltersTableSlice = createSlice({
  name: 'publisherReportsFiltersTable',
  initialState: {
    selectedApps: getLocalStorage('selectedApps', []),
    countriesFilter: getLocalStorage('countriesFilter', []),
    placementsFilter: getLocalStorage('placementsFilter', []),
    advertisersFilter: getLocalStorage('advertisersFilter', []),
    tableGrouping: getLocalStorage('tableGrouping', {}),
    tableSorting: getLocalStorage('tableSorting', null),
  },
  reducers: {
    clearAllFiltersExceptApps: (state, action) => {
      state.countriesFilter = [];
      state.placementsFilter = [];
      state.advertisersFilter = [];
    },
    updateTableGrouping: (state, action) => {
      const { requestName, groupingValue } = action.payload;
      state.tableGrouping[requestName] = groupingValue;
    },
    updateProperty: (state, action) => {
      if (Object.prototype.hasOwnProperty.call(state, action.payload.propField)) {
        state[action.payload.propField] = action.payload.newValue;
      } else {
        state[action.payload.propField] = action.payload.newValue;
      }
    },
  },
});

export const publisherReportsFiltersTableActions = publisherReportsFiltersTableSlice.actions;
publisherReportsFiltersTableActions.STORAGE_KEY = STORAGE_KEY;
export default publisherReportsFiltersTableSlice.reducer;
